import Form, { IChangeEvent } from '@rjsf/core';
import { ArrayFieldItemTemplateProps, ArrayFieldTemplateProps, FieldTemplateProps, ObjectFieldTemplateProps, RJSFSchema, SubmitButtonProps } from '@rjsf/utils';
import React from 'react'
import validator from '@rjsf/validator-ajv8';
import EledoButton from '../EledoButton';

export type EledoWebFormProps = {
  schema: RJSFSchema
  formData?: any
  onChange?: ((data: IChangeEvent<any, RJSFSchema, { arrayIndex: number }>, id?: string) => void) | undefined
  onSubmit?: ((data: IChangeEvent<any, RJSFSchema, { arrayIndex: number }>, event: React.FormEvent<any>) => void) | undefined
}

const EledoWebForm = ({schema, formData, onChange, onSubmit}: EledoWebFormProps) => {

  function ArrayFieldTemplate(props: ArrayFieldTemplateProps) {
    return (
      <div style={{paddingLeft: '15px', borderLeft: '1px solid black'}}>
        {props.items.map((element, index) => (
          <div key={element.key} className="array-item">
          {element}
        </div>
        ))}
        {props.canAdd && <button type='button' onClick={props.onAddClick}>Add</button>}
      </div>
    );
  }

  function ArrayFieldItemTemplate(props: ArrayFieldItemTemplateProps) {
    const { children, className, buttonsProps, displayLabel, hasDescription, hasToolbar, registry, uiSchema } = props;
    return (
      <div className={className} style={{flex: 1, paddingLeft: 6, paddingRight: 6, fontWeight: 'bold'}}>
        <div className={hasToolbar ? 'col-xs-9 col-md-10 col-xl-11' : 'col-xs-12'}>{children}</div>
        {hasToolbar && (
          <div className='col-xs-3 col-md-2 col-xl-1 array-item-toolbox'>
            <div className='btn-group' style={{}}>
              {buttonsProps.hasRemove && <button type='button' onClick={buttonsProps.onRemoveItem}>Remove</button>}
            </div>
          </div>
        )}
      </div>
    )
  }

  function ObjectFieldTemplate(props: ObjectFieldTemplateProps) {

    return (
      <div style={{paddingLeft: '15px', borderLeft: '1px solid black'}}>
        {props.properties.map((element) => element.content)}
      </div>
    );
  }

  function FieldTemplate(props: FieldTemplateProps) {
    const { id, classNames, style, label, help, required, description, errors, children, formData } = props;
    const hideLabel = formData?.arrayIndex > 0

    return (
      <fieldset className={classNames} style={style}>
        {!hideLabel && label &&
          <label htmlFor={id}>
            {label}
            {required ? '*' : null}
          </label>
        }
        {description}
        {children}
        {errors}
        {help}
      </fieldset>
    );
  }

  function SubmitButton(props: SubmitButtonProps) {
    return (
      <div className='text-center'>
        <EledoButton id="WebFormSubmit" label="Submit" primary={true} submit={true}/>
      </div>
    )
  }

  return (
    <Form
      schema={schema}
      formData={formData}
      onChange={onChange}
      onSubmit={onSubmit}
      validator={validator}
      templates={{ArrayFieldTemplate, ArrayFieldItemTemplate, ObjectFieldTemplate, FieldTemplate, ButtonTemplates: {SubmitButton}}}
      formContext={{arrayIndex: 0}}
      />
  )
}

export default EledoWebForm